import * as React from 'react';

function Share(props) {
	return (
		<svg
			aria-label={`share icon`}
			width={'20'}
			height={'20'}
			viewBox={'0 0 20 20'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>share icon</title>
			<path d={'M7.70272 10.1433C7.70272 8.65788 6.41224 7.39263 4.74267 7.39263C3.07309 7.39263 1.78262 8.65788 1.78262 10.1433C1.78262 11.6286 3.07309 12.8939 4.74267 12.8939C6.41224 12.8939 7.70272 11.6286 7.70272 10.1433Z'} stroke={'#1F1F1F'} strokeWidth={'1.2'} />
			<path d={'M18.7642 4.3993C18.7642 2.91392 17.4738 1.64867 15.8042 1.64867C14.1346 1.64867 12.8441 2.91392 12.8441 4.3993C12.8441 5.88469 14.1346 7.14994 15.8042 7.14994C17.4738 7.14994 18.7642 5.88469 18.7642 4.3993Z'} stroke={'#1F1F1F'} strokeWidth={'1.2'} />
			<path d={'M18.7642 16.0069C18.7642 17.4923 17.4738 18.7575 15.8042 18.7575C14.1346 18.7575 12.8441 17.4923 12.8441 16.0069C12.8441 14.5215 14.1346 13.2563 15.8042 13.2563C17.4738 13.2563 18.7642 14.5215 18.7642 16.0069Z'} stroke={'#1F1F1F'} strokeWidth={'1.2'} />
			<path d={'M6.64978 8.34828L13.007 5.59598'} stroke={'#1F1F1F'} strokeWidth={'1.2'} />
			<path d={'M6.64978 12.0579L13.007 14.8102'} stroke={'#1F1F1F'} strokeWidth={'1.2'} />
		</svg>
	);
}

export default Share;
